import type { SyntheticEvent } from 'react';

// Joins VITE_APP_CDN_URL + storage key. Returns null when key is missing
// so callers can branch on it (e.g. show a placeholder image).
export function imageUrl(key: string | null | undefined): string | null {
  if (!key) return null;
  const base = import.meta.env.VITE_APP_CDN_URL;
  if (!base) return null;
  const baseSlash = base.endsWith('/') ? base : `${base}/`;
  const cleanKey = key.replace(/^\//, '');
  return `${baseSlash}${cleanKey}`;
}

/** `onError` handler for `<img>` — hides the element when the source fails to load. */
export function hideOnImgError(e: SyntheticEvent<HTMLImageElement>): void {
  e.currentTarget.style.display = 'none';
}
